import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=47678b5e&scoped=true"
import script from "./UploadCard.vue?vue&type=script&lang=js"
export * from "./UploadCard.vue?vue&type=script&lang=js"
import style0 from "./UploadCard.vue?vue&type=style&index=0&id=47678b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47678b5e",
  null
  
)

export default component.exports